export default __webpack_public_path__ + "assets/close.609e33f6.svg";